import type { ReactNode } from 'react';
import { Outlet } from 'react-router';
import { NotFoundPage } from '../pages/NotFoundPage.js';
import { useAuth } from './AuthProvider.js';

/**
 * Admin-only surface. Non-admins get the real 404 page (no redirect), so the
 * admin section looks like it does not exist.
 */
export function AdminRoute({ children }: { children?: ReactNode }) {
  const { user } = useAuth();
  if (user?.role !== 'admin') return <NotFoundPage />;
  return children ?? <Outlet />;
}
